<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="pa-4"
  >
    <apexchart
      v-if="series"
      :options="options"
      :series="series"
      height="550px"
      type="area"
    />
    <v-card
      class="mt-4"
      outlined
    >
      <v-simple-table v-if="series">
        <template #default>
          <thead>
            <tr>
              <th
                class="text-left primary white--text"
                style="width: 120px"
              >
                {{ $t('time') }}
              </th>
              <th
                v-for="item in categories"
                :key="item"
                class="text-left text-no-wrap"
              >
                {{ item }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="text-left primary white--text"
                style="width: 120px"
              >
                {{ $t('sales') }}
              </td>
              <td
                v-for="item in series[0].data"
                :key="item"
                class="text-left text-no-wrap"
              >
                {{ item | priceDisplay }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-card>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    name: 'TurnOverFragment',
    props: {
      spanTurnover: { type: Object },
    },
    data: function () {
      return {
        series: null,
        categories: null,
        options: null,
      }
    },
    watch: {
      spanTurnover () {
        this.initGraph()
      },
    },
    mounted () {
      this.initGraph()
    },
    methods: {
      exportExcel () {
        const displayData = this.spanTurnover
        // 数据对齐
        const monthData = displayData.result.map(item => {
          return this.parseLabel(displayData.smallSelector, item.smallSelector)
        })
        const data = monthData.map(c => {
          return displayData.result.find(th => this.parseLabel(displayData.smallSelector, th.smallSelector) === c)?.spanTotal ?? '0.00'
        })
        const totalSpanTurnover = data.map(Number).reduce((x, y) => x + y)
        const turnoverList = [...data, totalSpanTurnover]
        const headTitle = monthData.push('总额')
        console.log(headTitle)
        // 直接导出文件
        const ExportJsonExcel = require('js-export-excel')

        const option = {}

        option.fileName = '时段销售统计'

        option.datas = [
          {
            sheetData: [turnoverList],
            sheetName: 'sheet',
            sheetHeader: monthData,
            columnWidths: [],
          },
        ]

        const toExcel = new ExportJsonExcel(option) // new
        toExcel.saveExcel() // 保存
      },
      parseLabel (dataType, data) {
        let res
        switch (dataType) {
          case 'hour':
            res = data + ':00'
            break
          case 'week':
            res = this.$i18n.tc('no_week', data)
            break
          case 'date':
            res = dayjs(data).format('DD.MM')
            break
          default:
          case 'month':
            res = dayjs().set('month', data - 1).format('MMM')
        }
        return res
      },
      getDataFromTurnoverData (list) {
        return list?.map(d => d.spanTotal) ?? []
      },
      initGraph () {
        const categories = this.spanTurnover?.result?.map(d => {
          let res
          switch (this.spanTurnover.smallSelector) {
            case 'hour':
              res = d.smallSelector + ':00'
              break
            case 'week':
              // res = `第${d.smallSelector + 1}周`
              res = this.$i18n.tc('no_week', d.smallSelector)
              break
            case 'date':
              console.log(d.smallSelector)
              res = dayjs(d.smallSelector).format('DD.MM')
              break
            default:
            case 'month':
              res = dayjs().set('month', d.smallSelector).format('MMM')
          }
          return res
        }) ?? []
        this.categories = categories

        const data = this.getDataFromTurnoverData(this.spanTurnover?.result)
        this.series = [
          {
            name: this.$i18n.t('period_turnover'),
            data: data,
          }]
        const maxNumber = Math.max(...data) ?? 1
        const tooLowNumberArr = []
        data?.forEach((item, index) => {
          const f = parseFloat(item)
          if ((f !== 0 && (maxNumber / f > 10)) || f <= 0) {
            tooLowNumberArr.push(index)
          }
        })
        this.options = {
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '14px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 'bold',
              colors: undefined,
            },
            formatter: function (value, {
              seriesIndex,
              dataPointIndex,
              w,
            }) {
              if (data.length < 8 || tooLowNumberArr.includes(dataPointIndex)) {
                return value + '€'
              } else {
                return ''
              }
            },
            offsetY: -8,
            distributed: true,
            background: {
              enabled: true,
              foreColor: '#fff',
              padding: 4,
              borderRadius: 4,
              borderWidth: 1,
              borderColor: '#fff',
              opacity: 0.9,
              dropShadow: {
                enabled: false,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45,
              },
            },
          },
          grid: { strokeDashArray: 8 },
          chart: {
            toolbar: { show: false },
            height: 480,
          },
          tooltip: {
            y: {
              formatter: (val) => {
                return val.toFixed(2) + ' €'
              },
            },
          },
          stroke: {
            curve: 'smooth',
          },
          yaxis: {
            forceNiceScale: true,
            opposite: true,
            min: 0,
            labels: {
              formatter: (val) => {
                if (val > 999) {
                  return (parseFloat(val) / 1000).toFixed(1) + 'k'
                } else if (val > 99) {
                  return parseFloat(val).toFixed(0)
                } else {
                  return parseFloat(val).toFixed(1)
                }
              },
            },
          },
          xaxis: {
            categories: categories,
            axisTicks: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              borderRadius: 8,
              distribute: true,
              columnWidth: '60%',
              dataLabels: {
                position: 'top',
                maxItems: 12,
                hideOverflowingLabels: true,
              },
            },

          },
        }
      },
    },
  }
</script>

<style scoped>

</style>
